// Transforms the div it is applied to into a scroll window
// that floats the content in it to the end of the div as the user scrolls.
// NOTE: This is not a wrapper! Insert this into the component you want to scroll.

import React, { useEffect, useRef } from "react";

export interface ScrollBalloonProps {
  screenTop: number;
}

const ScrollBalloon = ({ screenTop }: ScrollBalloonProps) => {
  const balloonRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!balloonRef.current) {
      return;
    }

    const balloon: HTMLDivElement = balloonRef.current;
    const parent = balloon.parentElement;

    if (!parent) {
      return;
    }

    let lastChild: any;

    const scrollListener = () => {
      const parentBoundingBox = parent.getBoundingClientRect();

      if (!parent.parentNode) {
        window.removeEventListener("scroll", scrollListener);
        window.removeEventListener("resize", scrollListener);
        return;
      }

      if (parent.offsetHeight === 0) {
        lastChild = null;
        return;
      }

      if (parent.offsetHeight === 0 || !lastChild) {
        lastChild = parent.lastElementChild;
      }

      const contentHeight =
        lastChild.offsetTop + lastChild.offsetHeight - balloon.offsetHeight;

      if (parentBoundingBox.top < screenTop) {
        const offsetY = Math.min(
          screenTop - parentBoundingBox.top,
          parent.offsetHeight - contentHeight
        );

        balloon.style.height = `${offsetY}px`;
      } else {
        balloon.style.height = "0";
      }
    };

    window.addEventListener("scroll", scrollListener);
    window.addEventListener("resize", scrollListener);

    setTimeout(scrollListener, 500);
    setTimeout(scrollListener, 1500);
    setTimeout(scrollListener, 4500);

    return () => {
      window.removeEventListener("scroll", scrollListener);
      window.removeEventListener("resize", scrollListener);
    };
  }, [screenTop]);

  return <div ref={balloonRef} className="scroll-balloon" />;
};

export default ScrollBalloon;
